import React, { useState, useRef } from 'react';

import { useNavigate } from 'react-router-dom';

import { 
  FaDraftingCompass, FaTools, FaTruckPickup, FaClipboardCheck, FaSearchDollar, 
  FaPlayCircle, FaChevronRight, FaCheck, FaPaintRoller, FaHammer, FaTree, 
  FaSwimmingPool, FaHome, FaLayerGroup, FaPlay, FaClock, FaArrowRight,
  FaPenNib, FaMapMarkedAlt, FaHardHat, FaCity, FaCouch, FaMountain, FaPiggyBank, FaFileSignature, FaKey, 
  FaBuilding, FaTractor, FaTruckMoving, FaWrench, FaBolt, FaSnowflake, 
  FaPaintBrush, FaBorderAll, FaBroom, FaSign, FaUserTie
} from 'react-icons/fa';



// Shared Components
import Header from './components/Header';
import Footer from './components/Footer';
import SearchFormComponent from "../../pages/Dashboards/SearchFormComponent"; 
import SocialProofEngine from '../../components/SocialProof/SocialProofEngine';

import ScamDetectorWidget from './components/ScamDetectorWidget';

import ConstructionTranslator from './components/ConstructionTranslator';

import AppDownloadSection from './components/AppDownloadSection'; 
import TestimonialsSection from './components/TestimonialsSection'; 
import FinalCtaSection from './components/FinalCtaSection'; 

import './ResourcesHubPageNew.css';

// --- DATA: PROFESSIONALS ---
const professionals = [
  // --- PHASE 1: PLANNING & DESIGN ---
  { name: "Architect", phase: "Planning & Design", color: "#6366f1", icon: <FaDraftingCompass />, desc: "Designs the master plan and creates detailed blueprints." },
  { name: "Draftsman", phase: "Planning & Design", color: "#4f46e5", icon: <FaPenNib />, desc: "Produces technical drawings and schematics for building approval." },
  { name: "Land Surveyor", phase: "Planning & Design", color: "#06b6d4", icon: <FaMapMarkedAlt />, desc: "Measures property boundaries and sets out the building footprint." },
  { name: "Structural Engineer", phase: "Planning & Design", color: "#0ea5e9", icon: <FaBuilding />, desc: "Designs frameworks and foundations to ensure building stability." },
  { name: "Town Planner", phase: "Planning & Design", color: "#3b82f6", icon: <FaCity />, desc: "Advises on zoning laws and secures local council development approvals." },
  { name: "Interior Designer", phase: "Planning & Design", color: "#d946ef", icon: <FaCouch />, desc: "Plans the layout, aesthetic styling, and finishes of interior spaces." },
  { name: "Geotechnical Engineer", phase: "Planning & Design", color: "#8b5cf6", icon: <FaMountain />, desc: "Analyzes soil and rock conditions to determine foundation requirements." },

  // --- PHASE 2: PRE-COMMENCEMENT / PROCUREMENT ---
  { name: "Quantity Surveyor", phase: "Procurement", color: "#10b981", icon: <FaSearchDollar />, desc: "Calculates material costs and manages budgets to keep projects on track." },
  { name: "Finance Broker", phase: "Procurement", color: "#059669", icon: <FaPiggyBank />, desc: "Connects clients with lending institutions to secure construction financing." },
  { name: "Conveyancer", phase: "Procurement", color: "#14b8a6", icon: <FaFileSignature />, desc: "Handles the legal transfer of property ownership and title deeds." },
  { name: "Buyers Agent", phase: "Procurement", color: "#f59e0b", icon: <FaKey />, desc: "Represents the buyer to source and negotiate property or land purchases." },
  { name: "Builder (Main Contractor)", phase: "Procurement", color: "#ea580c", icon: <FaHardHat />, desc: "The primary contractor overseeing the entire physical construction process." },

  // --- PHASE 3: CONSTRUCTION (SITE PREP & STRUCTURE) ---
  { name: "Demolition Worker", phase: "Construction", color: "#ef4444", icon: <FaTruckMoving />, desc: "Safely tears down and removes existing structures and debris." },
  { name: "Earthmoving Operator", phase: "Construction", color: "#c2410c", icon: <FaTractor />, desc: "Operates heavy machinery to clear, excavate, and level the site." },
  { name: "Concreter", phase: "Construction", color: "#f59e0b", icon: <FaTruckPickup />, desc: "Forms, pours, and finishes the concrete slab foundation." },
  { name: "Bricklayer", phase: "Construction", color: "#b45309", icon: <FaBuilding />, desc: "Lays bricks and blocks to construct walls, partitions, and foundations." },
  { name: "Carpenter", phase: "Construction", color: "#8b5cf6", icon: <FaHammer />, desc: "Builds the structural timber frame, roof trusses, and decking." },
  { name: "Roofer", phase: "Construction", color: "#64748b", icon: <FaHome />, desc: "Installs, repairs, and maintains the roof structure and weatherproofing." },

  // --- PHASE 4: CONSTRUCTION (ROUGH-IN & FIT-OUT) ---
  { name: "Plumber", phase: "Construction", color: "#0284c7", icon: <FaWrench />, desc: "Installs and repairs water, gas, and drainage pipe systems." },
  { name: "Electrician", phase: "Construction", color: "#eab308", icon: <FaBolt />, desc: "Handles high-risk wiring, safety switches, and power distribution." },
  { name: "HVAC Technician", phase: "Construction", color: "#0ea5e9", icon: <FaSnowflake />, desc: "Installs and maintains heating, ventilation, and air conditioning systems." },
  { name: "Plasterer", phase: "Construction", color: "#94a3b8", icon: <FaPaintRoller />, desc: "Installs drywall and applies plaster to create smooth interior walls." },
  { name: "Painter", phase: "Construction", color: "#ec4899", icon: <FaPaintBrush />, desc: "Applies protective and decorative paint finishes to interior and exterior surfaces." },
  { name: "Tiler", phase: "Construction", color: "#14b8a6", icon: <FaBorderAll />, desc: "Lays tiles on floors, walls, and wet areas like bathrooms and kitchens." },
  { name: "Cabinet Maker", phase: "Construction", color: "#a855f7", icon: <FaHammer />, desc: "Designs, builds, and installs custom kitchens, wardrobes, and joinery." },
  { name: "Landscaper", phase: "Construction", color: "#22c55e", icon: <FaTree />, desc: "Designs and constructs gardens, retaining walls, and outdoor living areas." },

  // --- PHASE 5: POST CONSTRUCTION (HANDOVER & SALES) ---
  { name: "Building Certifier", phase: "Post Construction", color: "#3b82f6", icon: <FaClipboardCheck />, desc: "Inspects work at critical stages to issue building compliance certificates." },
  { name: "Cleaner", phase: "Post Construction", color: "#06b6d4", icon: <FaBroom />, desc: "Performs a meticulous deep clean of the site prior to the client handover." },
  { name: "Real Estate Agent", phase: "Post Construction", color: "#f43f5e", icon: <FaSign />, desc: "Manages the marketing, negotiation, and sale of the completed property." },
  { name: "Property Manager", phase: "Post Construction", color: "#6366f1", icon: <FaUserTie />, desc: "Manages rental properties, tenant screening, and ongoing maintenance." }
];

// --- DATA: VIDEO DATA ---
const videoData = [
  {
    id: 1,
    title: "The 'Variation' Trap",
    duration: "13 MIN",
    desc: "Why costs change mid-project and how to manage contract variations.",
    youtubeId: "MBhgwn00PNo", // Undercover Architect: Building Contract Mistakes
    expertTip: "Never authorize extra work verbally. Always demand a 'Variation Order' signed by both parties BEFORE the work starts to protect yourself under Australian Consumer Law."
  },
  {
    id: 2,
    title: "The Vetting Gauntlet",
    duration: "8 MIN",
    desc: "How to check a builder's license and history before signing.",
    youtubeId: "d9asMJ_CVwA", // How to choose a builder (Aussie context)
    expertTip: "Always check the Fair Trading / QBCC / VBA register for your state. Look for license classes, active status, and any past disciplinary actions."
  },
  {
    id: 3,
    title: "Council Approvals 101",
    duration: "4 MIN",
    desc: "DA vs CDC? Understanding legal requirements for your state.",
    youtubeId: "BpH_FXFLO64", // Council Approval Group: DA vs CDC
    expertTip: "If your design fits within 'Complying Development' (CDC) rules, you can skip the Local Council drama and use a Private Certifier to save months of waiting."
  },
  {
    id: 4,
    title: "The 'Prime Cost' Illusion",
    duration: "25 MIN",
    desc: "How PC & PS allowances in HIA/MBA contracts blow out your budget.",
    youtubeId: "2Zcaq9UcA9w", // Undercover Architect: Prime Costs and Provisional Sums
    expertTip: "Select your fixtures (tiles, taps, lights) BEFORE signing the contract. Prime Costs are just estimates—if you pick a nicer tap later, you pay the difference plus a builder's margin (usually 20%)."
  },
  {
    id: 5,
    title: "The 'Low Bid' Trap",
    duration: "6 MIN",
    desc: "Why the cheapest building quote is usually the most dangerous.",
    youtubeId: "Ic0wx4kC1cQ", // Why quotes vary so much (Australian Builder)
    expertTip: "Throw out the highest and lowest quotes. If a quote is 20% lower than the rest, they missed something in the Bill of Quantities, or they plan to hit you with Variations later."
  },
  {
    id: 6,
    title: "The Handover / Blue Tape",
    duration: "15 MIN",
    desc: "How to handle your PCI (Practical Completion Inspection).",
    youtubeId: "hVvQX7zhGvs", // Site Inspections: What to look for at Practical Completion
    expertTip: "Do not pay the final invoice until you have formally noted every defect. You have a legally protected defect liability period (usually 13 weeks to 12 months depending on your state). Use an independent inspector."
  }
];

// --- DATA: PROJECT TEMPLATES ---
const projectTemplates = [
  { id: "100", title: "Cosmetic Kitchen Refresh", cost: "$20k - $60k", time: "3-6 Weeks", icon: "🍳", desc: "A facelift without structural changes. New cabinet fronts, benchtops, and appliances.", phases: ["Strip Out", "Rough-in", "Cabinet Install", "Splashback"], trades: ["Cabinet Maker", "Electrician", "Plumber", "Tiler"] },
  { id: "200", title: "Bathroom Renovation", cost: "$15k - $40k", time: "4-8 Weeks", icon: "🚿", desc: "Complete gut and replace. Requires waterproofing certification and precise tiling.", phases: ["Demo", "Waterproofing", "Tiling", "Fit-off"], trades: ["Plumber", "Waterproofer", "Tiler", "Electrician"] },
  { id: "300", title: "Knockdown Rebuild", cost: "$500k - $2M+", time: "12-24 Months", icon: "🏗️", desc: "Demolishing existing structure to build a custom modern home from scratch.", phases: ["DA Approval", "Slab Pour", "Frame", "Fit-out"], trades: ["Builder", "Excavator", "Concreter", "Certifier"] },
  { id: "108", title: "Full Interior Repaint", cost: "$10k - $40k", time: "2-4 Weeks", icon: <FaPaintRoller />, desc: "Repainting all internal walls, ceilings, doors, and trims to refresh the property.", phases: ["Sanding & Prep", "Masking", "Priming", "Top Coats"], trades: ["Painter", "Handyman"] },
  { id: "109", title: "New Flooring (Whole Home)", cost: "$15k - $50k", time: "2-3 Weeks", icon: <FaLayerGroup />, desc: "Replacing old carpet or tiles with new timber, vinyl, hybrid, or tile flooring.", phases: ["Remove Old Floor", "Level Slab", "Underlay", "Install"], trades: ["Flooring Installer", "Carpenter"] },
  { id: "300_Deck", title: "New Timber Deck", cost: "$15k - $60k", time: "2-4 Weeks", icon: <FaHammer />, desc: "Building a new timber or composite deck. Includes footings, sub-floor, and boards.", phases: ["Excavate Footings", "Sub-floor Frame", "Lay Decking", "Oiling"], trades: ["Carpenter", "Concreter", "Painter"] },
  { id: "305", title: "Landscaping Makeover", cost: "$20k - $100k+", time: "4-8 Weeks", icon: <FaTree />, desc: "Complete transformation of the garden. Earthworks, turf, planting, and retaining walls.", phases: ["Site Clearing", "Hardscaping", "Planting", "Turf"], trades: ["Landscaper", "Excavator", "Bricklayer"] },
  { id: "202", title: "Granny Flat Build", cost: "$120k - $250k", time: "3-6 Months", icon: <FaHome />, desc: "Constructing a self-contained secondary dwelling in the backyard.", phases: ["Approvals", "Slab", "Frame & Roof", "Fit-out"], trades: ["Builder", "Plumber", "Electrician", "Roofer"] },
  { id: "203", title: "Ground-Floor Extension", cost: "$100k - $400k", time: "4-8 Months", icon: "🏠", desc: "Extending the footprint of an existing home to add living space or bedrooms.", phases: ["Foundation", "Frame", "Roof Tie-in", "Internal Works"], trades: ["Builder", "Concreter", "Carpenter", "Roofer"] },
  { id: "303", title: "Swimming Pool", cost: "$50k - $120k+", time: "3-6 Months", icon: <FaSwimmingPool />, desc: "Excavation and installation of a concrete or fibreglass swimming pool.", phases: ["Excavation", "Shell Construction", "Filtration", "Fencing"], trades: ["Pool Builder", "Excavator", "Steel Fixer", "Tiler"] }
];

const ResourcesHubPage = () => {
  const navigate = useNavigate();
  const mountRef = useRef(null);
  const [activeTemplate, setActiveTemplate] = useState(projectTemplates[0]);
  const [activeVideo, setActiveVideo] = useState(videoData[0]);
  const [rotateAngle, setRotateAngle] = useState(0);

  // Carousel: 6-face hexagonal prism, 28 professions cycle through faces
  const faceCount = 6;
  const faceAngle = 60;
  const carouselRadius = 260;
  const totalProfs = professionals.length;

  // Which "step" we're on (how many times next has been pressed)
  const step = Math.round(-rotateAngle / faceAngle);
  const currentProfIndex = ((step % totalProfs) + totalProfs) % totalProfs;

  // Map each face to a profession based on current step
  const getFaceProf = (faceIdx) => {
    const frontFace = ((step % faceCount) + faceCount) % faceCount;
    const offset = ((faceIdx - frontFace) % faceCount + faceCount) % faceCount;
    const profIdx = ((currentProfIndex + offset) % totalProfs + totalProfs) % totalProfs;
    return professionals[profIdx];
  };

  const rotateCarousel = (direction) => {
    setRotateAngle(prev => direction === 'next' ? prev - faceAngle : prev + faceAngle);
  };

  const jumpToIndex = (targetIndex) => {
    let diff = targetIndex - currentProfIndex;
    if (diff > totalProfs / 2) diff -= totalProfs;
    if (diff < -totalProfs / 2) diff += totalProfs;
    setRotateAngle(prev => prev - diff * faceAngle);
  };

  return (
    <div className="bs-new-layout">
      <SocialProofEngine />
      <Header />

      {/* --- HERO SECTION --- */}
      <section className="rh-hero">
        <div className="rh-hero-overlay"></div>
        <div className="bs-container rh-hero-content">
          <div className="rh-tag">BUILD START ACADEMY</div>
          <h1 className="rh-title">
            MASTER THE ART OF <br/> 
            <span className="bs-text-gold-gradient">BUILDING</span>
          </h1>
          <p className="rh-subtitle">
            Don't get ripped off. Understand the process, learn the terminology, 
            and build with the confidence of an industry expert.
          </p>
          <div className="rh-search-wrapper">
             <SearchFormComponent />
          </div>
        </div>
      </section>

      {/* --- 3D PROFESSION CAROUSEL --- */}
      <section className="rh-section rh-carousel-section">
        <div className="bs-container">
          <div className="rh-section-header">
            <h2>BUILD YOUR "A-TEAM"</h2>
            <p>Meet the essential players required for a successful build.</p>
          </div>
          
          {/* Desktop: 3D hexagonal carousel (6 visible faces) */}
          <div className="rh-scene">
            <div
              className="rh-carousel"
              style={{ transform: `rotateY(${rotateAngle}deg)` }}
            >
              {Array.from({ length: faceCount }, (_, faceIdx) => {
                const prof = getFaceProf(faceIdx);
                return (
                  <div
                    className="rh-carousel-cell"
                    key={faceIdx}
                    style={{
                      transform: `rotateY(${faceIdx * faceAngle}deg) translateZ(${carouselRadius}px)`
                    }}
                  >
                    <div className="rh-prof-img-placeholder" style={{backgroundColor: prof.color + '15'}}>
                       <div className="rh-prof-icon" style={{color: prof.color}}>{prof.icon}</div>
                    </div>
                    <div className="rh-card-inner">
                      <h3>{prof.name}</h3>
                      <div className="rh-prof-phase">
                          <span className="rh-phase-label">PHASE:</span>
                          <span className="rh-phase-value" style={{color: prof.color}}>{prof.phase}</span>
                      </div>
                      <p>{prof.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Mobile: flat list of all professions */}
          <div className="rh-carousel-mobile">
            {professionals.map((prof, index) => (
              <div className="rh-carousel-cell" key={index}>
                <div className="rh-prof-img-placeholder" style={{backgroundColor: prof.color + '15'}}>
                   <div className="rh-prof-icon" style={{color: prof.color}}>{prof.icon}</div>
                </div>
                <div className="rh-card-inner">
                  <h3>{prof.name}</h3>
                  <div className="rh-prof-phase">
                      <span className="rh-phase-label">PHASE:</span>
                      <span className="rh-phase-value" style={{color: prof.color}}>{prof.phase}</span>
                  </div>
                  <p>{prof.desc}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="rh-controls">
            <button className="rh-btn-prev" onClick={() => rotateCarousel('prev')}>
               &larr; Prev Trade
            </button>
            <button className="rh-btn-next" onClick={() => rotateCarousel('next')}>
               Next Trade &rarr;
            </button>
          </div>

          <div className="rh-profession-select">
            <select
              className="rh-profession-dropdown"
              value={currentProfIndex}
              onChange={(e) => {
                const index = parseInt(e.target.value, 10);
                if (!isNaN(index)) {
                  jumpToIndex(index);
                }
              }}
            >
              {professionals.map((prof, index) => (
                <option key={index} value={index}>
                  {prof.name} — {prof.phase}
                </option>
              ))}
            </select>
          </div>
        </div>
      </section>


      {/* --- CONSTRUCTION TRANSLATOR SECTION --- */}
      <section className="rh-section rh-video-section">
        <div className="bs-container">
          <ConstructionTranslator />
        </div>
      </section>
      





{/* --- NEW VIDEO SECTION --- */}
      <section className="rh-section rh-video-section">
        <div className="bs-container">
          <div className="rh-section-header">
             <h2>THE ACADEMY VAULT</h2>
             <p>Australian-focused video tutorials to save you thousands in avoided mistakes.</p>
          </div>

          <div className="rh-video-container">
            {/* List Side */}
            <div className="rh-video-list">
              {videoData.map((video) => (
                <button 
                  key={video.id} 
                  className={`rh-video-btn ${activeVideo.id === video.id ? 'active' : ''}`}
                  onClick={() => setActiveVideo(video)}
                >
                  <div className="rh-video-btn-icon">
                    <FaPlayCircle />
                  </div>
                  <div className="rh-video-info">
                    <strong>{video.title}</strong>
                    <div className="rh-video-meta">
                      <FaClock size={12}/> {video.duration}
                    </div>
                  </div>
                  {activeVideo.id === video.id && <FaChevronRight className="rh-chevron"/>}
                </button>
              ))}
            </div>

            {/* Content Side (YouTube Embed) */}
            <div className="rh-video-display">
               
               {/* 16:9 Responsive YouTube Player */}
               <div className="rh-youtube-wrapper" style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px', backgroundColor: '#000' }}>
                  <iframe 
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    src={`https://www.youtube.com/embed/${activeVideo.youtubeId}?rel=0`} 
                    title={activeVideo.title} 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowFullScreen
                  ></iframe>
               </div>

               {/* Video Context & Expert Tip */}
               <div className="rh-script-box" style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #00d4ff' }}>
                  <h4 style={{ margin: '0 0 10px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FaClipboardCheck color="#00d4ff" /> 
                    Key Takeaway: {activeVideo.title}
                  </h4>
                  <p style={{ margin: '0 0 15px 0', fontSize: '15px', color: '#555' }}>
                    {activeVideo.desc}
                  </p>
                  <div className="rh-expert-highlight" style={{ backgroundColor: '#eef8ff', padding: '15px', borderRadius: '6px', fontSize: '14px', color: '#003366' }}>
                    <strong>Expert Tip:</strong> {activeVideo.expertTip}
                  </div>
               </div>

            </div>
          </div>
        </div>
      </section>


      {/* ---  SCAM DETECTOR SECTION --- */}
      {/* 
         This section acts as a full-width break. 
         The widget handles its own dark background and spacing. 
      */}
      <section className="rh-scam-section-container">
         <ScamDetectorWidget />
      </section>



      {/* --- ESTIMATOR SECTION --- */}
      <section className="rh-section">
        <div className="bs-container">
          <div className="rh-section-header">
             <h2>WHAT DOES IT TAKE?</h2>
             <p>Select a project to see the AI-generated breakdown.</p>
          </div>

          <div className="rh-estimator-grid">
            <div className="rh-estimator-controls">
              {projectTemplates.map((temp) => (
                <button 
                  key={temp.id} 
                  className={`rh-temp-btn ${activeTemplate.id === temp.id ? 'active' : ''}`}
                  onClick={() => setActiveTemplate(temp)}
                >
                  <span className="rh-temp-icon">{temp.icon}</span>
                  <div className="rh-temp-info">
                    <strong>{temp.title}</strong>
                    <small>{temp.time}</small>
                  </div>
                  <FaChevronRight className="rh-chevron"/>
                </button>
              ))}
            </div>

            <div className="rh-blueprint-card">
              <div className="rh-blueprint-top">
                  <div className="rh-bp-title">{activeTemplate.title}</div>
                  <div className="rh-bp-cost">{activeTemplate.cost}</div>
              </div>
              <p className="rh-bp-desc">{activeTemplate.desc}</p>
              
              <div className="rh-bp-row">
                  <div className="rh-bp-col">
                      <h4>Key Phases</h4>
                      <ul>
                          {activeTemplate.phases.map((p, i) => <li key={i}><FaCheck size={10}/> {p}</li>)}
                      </ul>
                  </div>
                  <div className="rh-bp-col">
                      <h4>Required Pros</h4>
                      <div className="rh-tags">
                          {activeTemplate.trades.map((t, i) => <span key={i}>{t}</span>)}
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <AppDownloadSection />

      <TestimonialsSection />


      <FinalCtaSection 
        title="Ready to start your project " 
        highlighttext="the right way?" 
        subtitle="Join thousands of owners who built with confidence using Build Start." 
      />



      <Footer />
    </div>
  );
};

export default ResourcesHubPage;